import { getConfigChangelog } from '@src/api/aiAlerts';
import { useQuery } from 'react-query';
import { get } from 'lodash';
import { CONFIG_LOG_KEY } from './alertsQueryKey.constants';

export const useFetchConfigChangelog = () => {
  const { data, isFetching, isLoading } = useQuery(CONFIG_LOG_KEY,
    () => {
      return getConfigChangelog().then((response) => get(response, ['data'], {}));
    },
    {
      retry: 3,
      refetchOnWindowFocus: false,
      onError: () => {
        throw new Error('AI alert config log fetch error');
      }
    },
  );

  return { data, isFetching, isLoading };
}
